function clearActive(array) {
  array.map((item) => item.classList.remove('active'));
}

export default clearActive;
